import { isAxiosError } from 'axios';
import { verifyReferralCode } from 'features/tap2mine-referral/api';
import { debounce } from 'lodash';
import { getToastMessage } from 'shared';

export const debouncedRefCodeValidator = debounce(
  async (value: string, callback: (result: boolean | string) => void) => {
    if (value.trim().length !== 8) {
      callback(false);
      return;
    }

    try {
      await verifyReferralCode(value.trim());
      callback(true);
    } catch (e) {
      if (isAxiosError(e) && e.status === 400) {
        getToastMessage('error', e.response?.data.error);
      }

      callback(false);
    }
  },
  850,
);
